import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const CompanyReport = React.lazy(() =>
    import('../CompanyReport')
);
const companyReportRoutesRegistry = [
    {
        path: PAGE_URL.COMPANY_REPORT_PAGE,
        element: <CompanyReport />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default companyReportRoutesRegistry;
